<template>
  <div>
    <ul class="field-preValues">
      <li v-for="( option, index ) in options"
          :key="option.id || index"
          class="field-preValues__preValue">
        <div class="checkbox">
          <input :id="`checkbox_${instanceId}_${option.id}`"
                 v-model="options[index].value"
                 :name="name"
                 class="checkbox"
                 type="checkbox">
          <label :for="`checkbox_${instanceId}_${option.id}`"
                 class="label"
                 :class="{ invalid: showValidation && !isValid }">
            {{ option.name }}
          </label>
        </div>
      </li>
    </ul>

    <div v-if="showValidation && !isValid"
         class="validation-message">
      <span>Required</span>
    </div>
  </div>
</template>

<script>

import vmodelMixin from "~/mixins/vmodelMixin";
import fieldMixin from "~/mixins/fieldMixin";
import validationMixin from "~/mixins/validationMixin";

export default {
  name: "CheckboxListField",
  mixins: [vmodelMixin, fieldMixin, validationMixin],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ( {
    mutable: null,
    options: []
  } ),
  computed: {
    isValid () {
      let result = true;

      if ( this.required ) {
        result = this.options.some( x => x.value );
      }

      return result;
    }
  },
  watch: {
    options: {
      handler ( val ) {
        this.copyToMutable( val );
        this.validate();
      },
      deep: true
    },
    mutable: {
      handler ( val ) {
        this.copyFromMutable( val );
      }
    }
  },
  created () {
    this.createFieldOptions();
    this.copyFromMutable( this.mutable );
  },
  methods: {
    createFieldOptions () {
      this.options = this.preValues.map( preValue => ( {
        value: null,
        ...preValue
      } ) );
    },
    copyToMutable ( options ) {
      if ( !this.mutable.fieldValues ) {
        this.mutable.fieldValues = [];
      }

      if ( options ) {
        options.forEach( option => {
          const matches = this.mutable.fieldValues.filter(
            x => x.name === this.name && x.value === option.name
          );

          if ( option.value ) {
            if ( matches.length === 0 ) {
              this.mutable.fieldValues.push( {
                fieldId: this.id,
                name: this.name,
                itemId: option.id,
                value: option.name
              } );
            } else {
              matches.forEach( match => {
                const index = this.mutable.fieldValues.indexOf( match );
                this.mutable.fieldValues[index].value = option.name;
              } );
            }
          } else if ( matches ) {
            matches.forEach( match => {
              const index = this.mutable.fieldValues.indexOf( match );
              this.mutable.fieldValues.splice( index, 1 );
            } );
          }
        } );
      }
    },
    copyFromMutable ( mutable ) {
      const { fieldValues } = mutable;

      let matchingFieldValues = [];
      if ( fieldValues ) {
        matchingFieldValues = fieldValues.filter( x => x.name === this.name );
      }

      if ( this.options ) {
        this.options.forEach( ( option, index ) => {
          const match = matchingFieldValues.find( x => x.value === option.name );
          this.options[index].value = !!match;
        } );
      }
    }
  }
};
</script>

<style>

</style>
